<template>
  <el-card>
    <h3 class="text-center">{{ message }}</h3>
  </el-card>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "home",
  data() {
    return {
      message: "正在绑定，请稍后..."
    };
  },
  props: {
    code: {
      type: String,
      required: false,
      default: ""
    },
    state: {
      type: String,
      required: false,
      default: ""
    }
  },
  computed: {
    ...mapState(["user"])
  },
  mounted: function() {
    this.$http
      .post("/wechatConnect", {
        code: this.code,
        state: this.state
      })
      .then(resp => {
        // bind wechat successfully
        if (resp.status == 200) {
          this.user.wechat_connected = true;
          this.message = "微信绑定成功，正在跳转...";
          let self = this;
          setTimeout(function() {
            self.$router.push("/user/edit");
          }, 3000);
        }
      })
      .catch(e => {
        this.message = e.response.data;
        this.$message({
          type: "error",
          message: this.message
        });
      });
  }
};
</script>
